module.exports = __webpack_public_path__ + "img/arrow-right.d94754d0.svg";